import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import { Link } from "react-router-dom";
import API from "../api/axios";

import videoBg from "../assets/Comming-Soon-Video.mp4";

import "../styles/ComingSoon.css";

import { useAuth } from "../components/AuthContext";

/* =========================================
   CONSTANTS
========================================= */

const START_RIDER = 5000;

/* =========================================
   COMPONENT
========================================= */

export default function ComingSoon() {

  const videoRef = useRef(null);

  const { user } = useAuth();

  /* =========================================
     STATES
  ========================================= */

  const [registered, setRegistered] =
    useState(START_RIDER);

  const [arenaStats, setArenaStats] =
useState({

  totalRegistered: START_RIDER,

  totalSlots: 20000,

  remainingSlots: 15000,

});

  const [loadingArena, setLoadingArena] =
    useState(false);

  const [enteredArena, setEnteredArena] =
    useState(false);

  const [showIntro, setShowIntro] =
    useState(true);

  const [showComingSoon, setShowComingSoon] =
    useState(false);

  const [showContent, setShowContent] =
    useState(false);

  /* =========================================
     LOAD LIVE STATS
  ========================================= */

  useEffect(() => {

    const loadArenaStats = async () => {

      try {

        const { data } = await API.get("/games/stats");

        setArenaStats({
  totalRegistered: data.totalRegistered,
  totalSlots: data.totalSlots,
  remainingSlots: data.remainingSlots,
});

      } catch (err) {

        console.error(
          "Arena Stats Error",
          err
        );

      }

    };

    loadArenaStats();

  }, []);

  /* =========================================
     COUNTER ANIMATION
  ========================================= */

  useEffect(() => {

    if (
      arenaStats.totalRegistered <=
      START_RIDER
    ) {

      setRegistered(
        START_RIDER
      );

      return;

    }

    let current =
      START_RIDER;

    const counter =
      setInterval(() => {

        current++;

        setRegistered(current);

        if (
          current >=
          arenaStats.totalRegistered
        ) {

          clearInterval(counter);

        }

      }, 15);

    return () =>
      clearInterval(counter);

  }, [arenaStats]);

  /* =========================================
     INTRO FLOW
  ========================================= */

  useEffect(() => {

    if (!enteredArena) return;

    const introTimer =
      setTimeout(() => {

        setShowIntro(false);

        setShowComingSoon(true);

      }, 8000);

    const contentTimer =
      setTimeout(() => {

        setShowComingSoon(false);

        setShowContent(true);

      }, 11000);

    return () => {

      clearTimeout(introTimer);

      clearTimeout(contentTimer);

    };

  }, [enteredArena]);

  /* =========================================
     SKIP INTRO
  ========================================= */

  const skipIntro = () => {

    setShowIntro(false);

    setShowComingSoon(false);

    setShowContent(true);

  };

  /* =========================================
     ENTER ARENA
  ========================================= */

  const enterArena = async () => {

    try {

      setLoadingArena(true);

      if (videoRef.current) {

        videoRef.current.currentTime = 0;

        videoRef.current.muted = false;

        videoRef.current.volume = 1;

        try {

          await videoRef.current.play();

        } catch (error) {

          console.error(error);

        }

      }

      setEnteredArena(true);

      setLoadingArena(false);

    } catch (error) {

      console.error(error);

      setLoadingArena(false);

    }

  };

  /* =========================================
     LIVE STATS
  ========================================= */

  const remaining =
  arenaStats.remainingSlots;

  const progress =
    (registered /
      arenaStats.totalSlots) *
    100;
    return (

  <section className="coming-page">

    {/* =========================================
        ENTER ARENA
    ========================================= */}

    {!enteredArena && (

      <div className="arena-entry">

        <h1 className="arena-logo">
          SAC ARENA
        </h1>

        <p className="arena-tagline">
          The Adventure Begins Here
        </p>

        <div className="rotate-message">

          <h3>
            🎮 BEST EXPERIENCE IN LANDSCAPE
          </h3>

          <p>

            For the ultimate

            <strong>
              {" "}SAC Arena{" "}
            </strong>

            experience, rotate your device to

            <strong>
              {" "}Landscape Mode
            </strong>

            before entering the arena.

          </p>

          <span>

            🔄 Rotate your device and tap

            <strong>
              {" "}ENTER SAC ARENA
            </strong>

          </span>

        </div>

        <button

          className="enter-arena-btn"

          disabled={loadingArena}

          onClick={enterArena}

        >

          {

            loadingArena

              ? "Entering Arena..."

              : "▶ ENTER SAC ARENA"

          }

        </button>

      </div>

    )}

    {/* =========================================
        VIDEO
    ========================================= */}

    <video

      ref={videoRef}

      className="video-bg"

      playsInline

      preload="auto"

    >

      <source

        src={videoBg}

        type="video/mp4"

      />

    </video>

    {/* =========================================
        OVERLAY
    ========================================= */}

    <div className="video-overlay" />

    <div className="fog fog-one" />

    <div className="fog fog-two" />

    <div className="fog fog-three" />

    {/* =========================================
        SKIP INTRO
    ========================================= */}

    {

      enteredArena &&

      showIntro && (

        <button

          className="skip-intro"

          onClick={skipIntro}

        >

          Skip Intro

        </button>

      )

    }

    {/* =========================================
        INTRO
    ========================================= */}

    {

      enteredArena &&

      showIntro && (

        <div className="intro-screen" />

      )

    }

    {/* =========================================
        COMING SOON
    ========================================= */}

    {

      enteredArena &&

      showComingSoon && (

        <div className="coming-soon-screen">

          <h1 className="coming-title">

            COMING SOON

          </h1>

          <p className="coming-subtitle">

            SAC ARENA

          </p>

        </div>

      )

    }

    {/* =========================================
        MAIN CONTENT
    ========================================= */}

    {

      enteredArena &&

      showContent && (

        <div className="hero-content">

          <div className="coming-wrapper">

            {/* ===========================
                LEFT
            =========================== */}

            <div className="coming-left">

              <h1>

                SAC ARENA

                <br />

                <span>

                  The Future of Adventure

                </span>

              </h1>

              <p>

                Experience India's most thrilling MTB adventure.

Explore epic worlds, complete exciting missions,
conquer challenging trails, unlock exclusive rewards,
and play every month for a chance to win
a premium SAC MTB Mountain Bicycle.

              </p>
                            {/* =========================================
                  PARTICIPATION CARD
              ========================================= */}

              {user?.gameRegistered && (

                <div className="participation-card">

                  <h3>
                    🎉 Registration Successful
                  </h3>

                  <div className="participation-grid">

                    <div className="participation-item">

                      <span>
                        Participation ID
                      </span>

                      <strong>
                        {user?.participationId || "Pending"}
                      </strong>

                    </div>

                    <div className="participation-item">

                      <span>
                        Rider Number
                      </span>

                      <strong>
                        #{user?.riderNumber || "--"}
                      </strong>

                    </div>

                  </div>

                </div>

              )}

              {/* =========================================
                  LIVE REGISTRATION
              ========================================= */}

              <div className="registration-card">

                <div className="registration-header">

                  <span>
                    Registered Riders
                  </span>

                  <strong>
                    {registered.toLocaleString()}
                  </strong>

                </div>

                <div className="progress">

                  <div
                    className="progress-fill"
                    style={{
                      width: `${progress}%`,
                    }}
                  />

                </div>

                <div className="registration-footer">

                  <span>
                    Remaining Slots
                  </span>

                  <strong>
                    {remaining.toLocaleString()}
                  </strong>

                </div>

              </div>

              {/* =========================================
                  FEATURES
              ========================================= */}

              <div className="feature-grid">

                <div className="feature-box">

                  <h4>
                    🌎 Massive Open World
                  </h4>

                  <p>
                    Explore mountains,
                    forests, deserts,
                    rivers and cities
                    in one huge world.
                  </p>

                </div>

                <div className="feature-box">

                  <h4>
                    🎁 Daily Rewards
                  </h4>

                  <p>
                    Complete missions,
                    collect rewards,
                    bikes and coins.
                  </p>

                </div>

                <div className="feature-box">

                  <h4>
                    🏆 Championships
                  </h4>

                  <p>
                    Compete in national
                    tournaments and
                    dominate the leaderboard.
                  </p>

                </div>

              </div>

            </div>

            {/* =========================================
                RIGHT COLUMN STARTS
            ========================================= */}

            <div className="coming-right">
                          {/* =========================================
                  LAUNCH CARD
              ========================================= */}
                

              {/* =========================================
                  PRE-REGISTRATION REWARDS
              ========================================= */}

              <div className="reward-card">

                <h3>
                  🎁 Pre-Registration Rewards
                </h3>

                <ul>

                  <li>
                    ✅ Limited Edition MTB
                  </li>

                  <li>
                    ✅ Premium Outfit
                  </li>

                  <li>
                    ✅ Arena Coins
                  </li>

                  <li>
                    ✅ Early Access
                  </li>

                </ul>

              </div>

              {/* =========================================
                  LIVE STATS
              ========================================= */}

              <div className="stats-card">

                <div className="stat-item">

                  <h2>
                    {registered.toLocaleString()}
                  </h2>

                  <span>
                    Registered Riders
                  </span>

                </div>

                <div className="stat-item">

                  <h2>
                    {arenaStats.totalSlots.toLocaleString()}
                  </h2>

                  <span>
                    Total Slots
                  </span>

                </div>

                <div className="stat-item">

                  <h2>
                    {remaining.toLocaleString()}
                  </h2>

                  <span>
                    Remaining
                  </span>

                </div>

              </div>

            </div>

          </div>
         

          {/* =========================================
              COMMUNITY
          ========================================= */}

          <div className="community-section">

            <h3>

              Join The Community

            </h3>

            <p>

              Follow SAC MTB for exclusive
              updates, trailers, tournaments,
              giveaways and launch announcements.

            </p>

            <div className="community-links">

              <a
                href="https://instagram.com/sacmtb"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>

              <a
                href="https://www.facebook.com/share/1HoANsoczL/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>

              <a
                href="https://youtube.com/@sacmtb"
                target="_blank"
                rel="noreferrer"
              >
                YouTube
              </a>

              {/* <a
                href="https://discord.gg"
                target="_blank"
                rel="noreferrer"
              >
                Discord
              </a> */}

            </div>

          </div>
                 {/* =========================================
    EXPLORE COLLECTION
========================================= */}

<div className="coming-cta">

  <span className="cta-badge">
    🚴 Explore SAC MTB Collection
  </span>

  <h2>
    Continue Your Adventure
  </h2>

  <p>
    While SAC Arena is getting ready for launch, explore our premium
    collection of Mountain Bicycles and Kids Ride-On Toys designed for
    every adventure.
  </p>

  <div className="cta-buttons">

    <Link
      to="/products"
      className="primary-btn"
    >
      🚴 Explore Bicycles
    </Link>

    <Link
      to="/toys"
      className="secondary-btn"
    >
      🚗 Explore Ride-On Toys
    </Link>

  </div>

</div>
      
      {/* =========================================
          FOOTER
      ========================================= */}

      <footer className="coming-footer">

        <p>

          © {new Date().getFullYear()} SAC MTB

        </p>

        <span>

          SAC ARENA • Adventure Begins Here • All Rights Reserved

        </span>

      </footer>

        </div>


      )}



    </section>

  );

}